(function documentContainerControllerDefinition() {
    'use strict';

    angular.module('DocumentContainer')
        .controller('DocumentContainerSelectModalController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'documentContainerService',
            'containerTypeService', 'userQueryService', '$q', '$modalInstance', 'info', 'documentTypes', '$filter',
            function documentTypeController($scope, config, $state, $translate, errors, documentContainerService,
                containerTypeService, userQueryService, $q, $modalInstance, info, documentTypes, $filter) {
                $scope.documentTypes = documentTypes;
                $scope.info = info;

                $scope.accordionState = {
                    isOpen: true
                }

                $translate(['PaginationNext', 'PaginationPrev', 'PaginationLastFem', 'PaginationFirstFem'])
                    .then(function (translated) {
                        $scope.paginatorTranslations = {
                            nextText: translated.PaginationNext,
                            previousText: translated.PaginationPrev,
                            lastText: translated.PaginationLastFem,
                            firstText: translated.PaginationFirstFem
                        };
                    });

                $scope.data = {
                    currentPage: 1,
                    totalItems: 0,
                    itemsPerPage: 15,
                    from: 0
                };

                $scope.filters = {};

                $scope.items = [];
                $scope.showResult = false;
                $scope.optionsContainerTypes = [];

                $scope.aux = {
                    selectedContainerType: null
                };

                $scope.clean = function () {
                    $scope.aux.selectedContainerType = null;

                    $scope.filters = {
                        showNoData: false,
                        containerTypes: [],
                        Name: ''
                    };

                    $scope.items = [];
                    $scope.accordionState.isOpen = true;
                    $scope.showResult = false;
                }

                $scope.LoadMetadata = function (containerType) {

                    var type = {
                        SystemName: containerType.systemName,
                        containerTypeName: containerType.name,
                        containerTypeId: containerType.id,
                        metadatas: []
                    };

                    containerType.metadata.forEach(function (metadata) {
                        if (metadata.isSearchCriteria) {
                            type.metadatas.push({
                                idObject: type.containerTypeId + '' + metadata.metadataId,
                                metadataId: metadata.metadataId,
                                metadataValueFrom: undefined,
                                metadataValueTo: undefined,
                                metadataSearchTypeFrom: undefined, // cada control pisa el valor
                                metadataSearchTypeTo: undefined, // cada control pisa el valor
                                metadataType: metadata.metadataType,
                                metadataSystemName: metadata.metadataSystemName,
                                metadataLabel: metadata.metadataLabel,
                                metadataOptions: metadata.optionValues,
                                mask: metadata.metadataMask,
                                maskPlaceHolder: metadata.metadataMaskPlaceHolder
                            });
                        }
                    });

                    $scope.filters.containerTypes.push(type);
                }

                $scope.selectContainerType = function (containerType) {

                    $scope.filters.containerTypes = [];

                    containerTypeService.getById(containerType.id, 'Detail')
                        .then(function (result) {
                            $scope.LoadMetadata(result);
                        }, function (error) {
                            errors.showError(error);
                        });
                };

                $scope.getContainers = function (page) {

                    $scope.showResult = true;

                    var type = angular.copy($scope.filters.containerTypes[0]);

                    type.page = page || 1,
                        type.itemPerPage = $scope.data.itemsPerPage;
                    type.documentTypeId = type.containerTypeId;
                    // Evitamos la fecha 1900 en los metadatos de busqueda.
                    var dateMetadatas = $filter('filter')(type.metadatas, { metadataType: "date" }, true);
                    angular.forEach(dateMetadatas, function (item) {
                        if (item.metadataValueFrom < '19010101') {
                            item.metadataValueFrom = null;
                        }

                        if (item.metadataValueTo === '') {
                            item.metadataValueTo = null;
                        }
                    });


                    var filters = {
                        complete: true,
                        containerTypes: [type],
                        checkOutByCurrentUser: true
                    };

                    return documentContainerService.advancedGet(filters)
                        .then(function getOk(result) {
                            $scope.items = result.values;

                            if ($scope.items.length > 0) {
                                $scope.accordionState.isOpen = false;
                            }

                            $scope.headers = result.headers;
                            $scope.data.totalItems = result.valuesCount;
                            $scope.data.from = result.valuesFrom;
                            $scope.data.currentPage = 1;

                            if ($scope.items.length === 0) {
                                $scope.filters.showNoData = true;
                            }

                            // los seleccionados los deshabilito.
                            angular.forEach($scope.items, function (item) {
                                if ($scope.info.selected[item.id]) {
                                    item.isDisabled = true;
                                }
                            });

                        }, function getError(error) {
                            errors.showError(error);
                        });
                };

                $scope.actionFind = function () {

                    $scope.items = [];
                    $scope.filters.showNoData = false;
                    $scope.showResult = false;

                    if (!$scope.filtersForm.$valid || $scope.filters.containerTypes.length <= 0) {
                        $scope.filtersForm.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return;
                    }

                    return $scope.getContainers();
                };

                $scope.pageFind = function () {
                    $scope.getContainers($scope.data.currentPage);
                };

                $scope.selectContainer = function (container) {
                    if (!container.isDisabled) {
                        $modalInstance.close(container);
                    }
                };

                $scope.cancel = function () {
                    $modalInstance.close(null);
                };

                $scope.clean();

                var docTypeIds = [];

                if ($scope.documentTypes != null) {
                    for (var i = 0; i < $scope.documentTypes.length; i++) {
                        var docType = $scope.documentTypes[i];

                        if ($scope.documentTypes[i].documentTypeId) {
                            docTypeIds.push(docType.documentTypeId);
                        }
                        else {
                            if (docType.documentDocumentTypes) {
                                for (var j = 0; j < docType.documentDocumentTypes.length; j++) {
                                    docTypeIds.push(docType.documentDocumentTypes[j].documentTypeId);
                                }
                            }
                        }
                    }
                }

                containerTypeService.getByDocType(docTypeIds).then(function (result) {

                    if (result.length > 0) {
                        $scope.optionsContainerTypes = result.sort(function (a, b) {
                            return a.name.localeCompare(b.name);
                        });
                    }

                }, function (error) {
                    errors.showError(error);
                });

            }]);
})();